import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { namesList as counterpartiesList } from "sources/books/cargoOwners";

export const config = {
    counterpartyId: {
        label: "Контрагент",
        inputProps: { name: "counterpartyId" },
        url: counterpartiesList,
        propName: "name",
        menuPortalTarget: document.body,
    },
    from: {
        label: "Период от",
        inputProps: { name: "from", type: "date" },
        inPortal: true,
        required: true,
        validators: [requiredField],
    },
    to: {
        label: "Период до",
        inputProps: { name: "to", type: "date" },
        inPortal: true,
        required: true,
        validators: [requiredField],
    },
    manualBidIds: {
        label: "ID заявок",
        inputProps: { name: "manualBidIds" },
        textarea: true,
    },
};

export const initialState = {
    ...getInitialStateFromConfig(config),
    bids: [],
    loadingBids: false,
    sourceMode: "search",
    selectedBidIds: [],
};
